var elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){
        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
        }
    }
    return contLogin;
}

$('.btnFormQuotation').click(function () {
    //$('#formQuotation').submit();
    grecaptcha.ready(function() {
        grecaptcha.execute('6LeaIIkkAAAAALppbcYBsDBy5YsYI50NwTn5NF0o', {action: 'submit'}).then(function(token) {
            $('#formQuotation').prepend('<input type="hidden" name="token" value="' + token + '">');
            $('#formQuotation').submit();
        });
    });
});


$('#formQuotation').on('submit',function (e) {
    e.preventDefault();
    elementsForm = [
        "id_car",
        "name_car",
        "lastname_car",
        "phone_car",
        "mail_car",
        "asesor_car",
        "messague_car",
    ];
    if(!$('#checkbox_car').is(':checked') ) {
        swal({
            text: "Debes aceptar las politicas de privacidad",
            icon: 'warning',
            button: "OK",
        });
        return false;
    }
    contLogin = validationForm(elementsForm,contLogin = 1);
    if(contLogin == 0)
    {
        swal({
            text: "Debes digitar todos los datos requeridos",
            icon: 'warning',
            button: "OK",
        });
        return false;
    }
    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: false,
        button: false,
        closeOnClickOutside: false,
    });
    $.ajax({
        url: "/quotation",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formQuotation")[0].reset();
                swal({
                    text: "Gracias por cotizar, pronto nos pondremos en contacto con usted",
                    icon: "success",
                    button: "OK",
                });
                location.href = '/informacion/gracias';
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: "warning",
                    button: "OK!",
                });
            }
        }
    });
});